import styled from 'styled-components';

export const Container = styled.div`
    height: 100%;
    margin-top: 0; 
    padding: 15px 24px 0 24px;

    .content-header-list{
        display: flex;
        margin-left: 20; 
        justify-content: space-between; 
        width: 100%;

        
        .btn-new-tenant{
            float: right; 
            margin-right: 20;
        }
    }

    .ant-pagination{
        float: right
    }     
`;

export const ContentModal = styled.div`
   
    .ant-modal-label-name{
        font-weight: bold;
    }
`;

export const ContentTable = styled.div`
    background-color: #F8F8F8; 
    height: 100%;
    opacity: 1;
    width: 100%;
    box-shadow: none;

    .ant-table-column-sorters > span{
        color: #929292; 
        opacity: 1;
    }

    .header-search{
        margin-top: 12px;
        
        @media only screen and (max-width: 480px) {

            .space-search{
                margin: 2px 0px;
                width: 100% !important;
            }
        }

        @media only screen and (min-width: 481px) and (max-width: 630px) {
            .space-search{
                margin: 2px 0px;
                width: 100% !important;
            }
        }

        @media only screen and (min-width: 630px) and (max-width: 768px) {
            .space-search{
                margin: 2px 2px;
                width: 220px !important;
            }
        }

        @media only screen and (min-width: 768px) and (max-width: 992px) {

            .space-search{
                margin: 2px 2px;
            }
        }

        @media only screen and (min-width: 992px) and (max-width: 1200px) {

            .space-search{
                margin: 2px 2px;
                width: 190px !important;
            }
        }

        @media only screen and (min-width: 1200px) and (max-width: 1600px) {

            .space-search{
                margin: 2px 2px;
                width: 200px !important;
            }
        }

        @media only screen and (min-width: 1600px) and (max-width: 1900px) {

            .space-search{
                margin: 2px 2px;
                width: 230px !important;
            } 
        }

        .space-search{
            margin: 2px 2px;
            width: 250px;
        }

        .pl-15{
            padding-left: 0px !important;
        }

        .ml-15{
            margin-left: 0px !important;
        }
    }

    .table{
        margin-top: 30px;
    }

    .tag-columns{
        width: 96px;
        height: 24px;
        text-align: center;
    }
`;